export default [
  {
    path: '/reportes-admin',
    name: 'adminReports',
    redirect: { name: 'adminReportsWeekly' },
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reportes-admin/semanal',
    name: 'adminReportsWeekly',
    component: () => import('@/views/reports/AdminReports.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reportes-admin/clientes-semanal',
    name: 'adminReportsWeeklyCustomers',
    component: () => import('@/views/reports/AdminReportsCustomerWeekly.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reportes-admin/mensual',
    name: 'adminReportsMonthly',
    component: () => import('../../views/reports/AdminReportsMonthly.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reportes-admin/clientes-mensual',
    name: 'adminReportsMonthlyCustomers',
    component: () => import('@/views/reports/AdminReportsCustomerMonthly.vue'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/reportes/:projectId',
    name: 'reports',
    component: () => import('@/views/reports/Dashboard.vue'),
    meta: {
      requiresAuth: true,
      // breadcrumb: [
      //   {
      //     text: 'projects',
      //     to: {
      //       name: 'projects',
      //     },
      //   },
      //   {
      //     text: 'dashboard',
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: '/reportes/ingresos-egresos/:projectId',
    name: 'incomesVsExpenses',
    component: () => import('@/views/reports/IncomesVsExpenses.vue'),
    meta: {
      navActiveLink: 'reports',
      requiresAuth: true,
    },
  },
  {
    path: '/reportes/egresos/:projectId',
    name: 'expensesReport',
    component: () => import('@/views/reports/ExpensesReport.vue'),
    meta: {
      navActiveLink: 'reports',
      requiresAuth: true,
    },
  },
]
